var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-view"},[_c('div',{staticClass:"box-overlay"}),_vm._m(0),_c('div',{staticClass:"left-container"},[_c('img',{staticClass:"left-view-img",attrs:{"src":_vm.coverImage,"alt":"background image"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":require("../../assets/images/talent-logo-default-monochrome.svg"),"alt":"Talent Logo"}})])
}]

export { render, staticRenderFns }